var EndorsementKeyInfo_1;
import { __decorate } from "tslib";
import { AsnType, AsnTypeTypes, AsnPropTypes, AsnArray } from "@peculiar/asn1-schema";
export const id_enrollEKInfo = "1.3.6.1.4.1.311.21.23";
let EndorsementKeyInfo = EndorsementKeyInfo_1 = class EndorsementKeyInfo extends AsnArray {
    constructor(items) {
        super(items);
        Object.setPrototypeOf(this, EndorsementKeyInfo_1.prototype);
    }
};
EndorsementKeyInfo = EndorsementKeyInfo_1 = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence, itemType: AsnPropTypes.Any })
], EndorsementKeyInfo);
export { EndorsementKeyInfo };
